/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const updatePolicyPlanBodyBlockThresholdMin = 0;
export const updatePolicyPlanBodyBlockThresholdMax = 1;

export const updatePolicyPlanBodyReviewThresholdMin = 0;
export const updatePolicyPlanBodyReviewThresholdMax = 1;

export const updatePolicyPlanBodySeverityMax = 5;

export const UpdatePolicyPlanBody = zod
	.object({
		action_canvas: zod.record(zod.string(), zod.unknown()).optional(),
		block_threshold: zod
			.number()
			.min(updatePolicyPlanBodyBlockThresholdMin)
			.max(updatePolicyPlanBodyBlockThresholdMax)
			.optional()
			.describe('Block threshold as a decimal'),
		display_name: zod.string().nullish().describe('Policy plan display name'),
		formats: zod
			.array(zod.enum(['text', 'image']))
			.optional()
			.describe('Content formats'),
		review_threshold: zod
			.number()
			.min(updatePolicyPlanBodyReviewThresholdMin)
			.max(updatePolicyPlanBodyReviewThresholdMax)
			.optional()
			.describe('Review threshold as a decimal'),
		severity: zod
			.number()
			.min(1)
			.max(updatePolicyPlanBodySeverityMax)
			.nullish()
			.describe('Severity level (1-5)')
	})
	.describe('Request body for updating a policy plan');

export type UpdatePolicyPlanBody = zod.input<typeof UpdatePolicyPlanBody>;
export type UpdatePolicyPlanBodyOutput = zod.output<typeof UpdatePolicyPlanBody>;
